const TAX_RATE_DECIMALS = 2;

// The API stores the rate in 32-bit precision and serializes it widened to a
// double, so a saved 31.97 reads back as 31.969999313354492.
export const selectorTaxRateLabel = (rate: number): string =>
  `${Number(rate.toFixed(TAX_RATE_DECIMALS))}%`;
